module.exports = __webpack_public_path__ + "static/media/7.350b9812.JPG";